import { Image } from '@heroui/react';
import React, { PropsWithChildren } from 'react';

type ClinicalSectionProps = {
  icon: string;
  header: string;
  className?: string;
  color: string;
  endContent?: React.ReactNode;
} & PropsWithChildren;

export const ClinicalSection = ({
  className = '',
  children,
  icon,
  header,
  endContent,
  color,
}: ClinicalSectionProps) => {
  return (
    <section className={`bg-white rounded-2xl p-3 h-full ${className}`}>
      <div className="flex flex-col gap-4 h-full">
        <div className="flex justify-between items-center gap-2 flex-wrap">
          <div className="flex gap-3 items-center">
            <div className={`flex items-center justify-center ${color} rounded-full w-10 h-10`}>
              <Image src={icon} />
            </div>
            <h2 className="text-hm">{header}</h2>
          </div>
          {endContent}
        </div>
        <div className="flex flex-1 justify-center items-center">
          {children || (
            <div className="flex flex-col gap-4 items-center justify-center opacity-45">
              <Image height={40} width={40} src={icon} />
              <div color="black">No measurements have been added</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
